import React, { Component } from "react";

export default class Contact extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      subject: '',
      message: '',
    };

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleSubjectChange = this.handleSubjectChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleNameChange(event) {
    this.setState({name: event.target.value});
  }

  handleEmailChange(event) {
    this.setState({email: event.target.value});
  }

  handleSubjectChange(event) {
    this.setState({subject: event.target.value});
  }

  handleMessageChange(event) {
    this.setState({message: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(this.state);
  }

  render() {


    
    return (
      <div className="contact section" id="Contact">
        <div className="container">
          <div className="section-head">
            <h2 className="text-center">Contact</h2>
          </div>
          <form
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={this.handleSubmit}
          >
            <div>
              <label>
                Your Name: <input type="text" name="name" value={this.state.name} onChange={this.handleNameChange} required />
              </label>
            </div>
            <div>
              <label>
                Your Email: <input type="email" name="email" value={this.state.email} onChange={this.handleEmailChange} required />
              </label>
            </div>
            <div>
              <label>
                Subject: <input type="text" name="subject" value={this.state.subject} onChange={this.handleSubjectChange} required />
              </label>
            </div>
            <div>
              <label>
                Message: <textarea name="message" value={this.state.message} onChange={this.handleMessageChange} required></textarea>
              </label>
            </div>
            <div>
              <button type="submit">Send</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
